
    import Testimonials from './Testimonials.vue';

    export default {
        name: 'ProjectsSection',
        components: {
            Testimonials,
        },
    };
